import React from 'react';
import Table from 'cccisd-graphql-table';

import { TestStatus } from '../devopsRenders';
import tableQuery from './buildsTable.graphql';

const BuildsTable = props => {
    const columns = [
        { name: 'buildId', label: 'Build ID', sort: true, filter: true },
        { name: 'app', label: 'App', sort: true, filter: true },
        { name: 'tag', label: 'Tag', sort: true, filter: true },
        { name: 'builtAt', label: 'Built At', sort: true, filter: true },
        {
            name: 'recentTestStatus',
            label: 'Test Status',
            sort: true,
            filter: true,
            filterSettings: {
                type: 'selectbox',
                placeholder: '-- Choose one --',
                options: [
                    { label: 'In Progress', value: '1' },
                    { label: 'Success', value: '2' },
                    { label: 'Failure', value: '3' },
                ],
            },
            render: rowProps => <TestStatus {...rowProps} />,
        },
        { name: 'lastDeployedAt', label: 'Last Deployed At', sort: true, filter: true },
    ];

    return <Table query={tableQuery} rowKey="buildId" orderBy="buildId" isAscentOrder={false} columns={columns} />;
};

export default BuildsTable;
